import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { PrintService } from 'src/app/common/services/print.service';
import {
  CROSS,
  PRINTER_LIST_ICON,
  ERROR_PRINTER,
  PRINTER_BTN_ICON,
  SUCCESS_PRINTER,
  PRINTER_STATUS_CONNECTION,
  YEL_INFO
} from 'src/defaultImages.js';
import { PrinterStatusService } from '../../services/printer-status.service';
@Component({
  selector: 'app-delay-printing',
  templateUrl: './delay-printing.component.html',
  styleUrls: ['./delay-printing.component.css'],
})
export class DelayPrintingComponent implements OnInit {
  images = {
    CROSS: CROSS,
    PRINTER_LIST_ICON: PRINTER_LIST_ICON,
    ERROR_PRINTER: ERROR_PRINTER,
    PRINTER_BTN_ICON: PRINTER_BTN_ICON,
    SUCCESS_PRINTER: SUCCESS_PRINTER,
    PRINTER_STATUS_CONNECTION: PRINTER_STATUS_CONNECTION,
    YEL_INFO:  YEL_INFO
  };
  subscription = new Subscription();
  translationText: any;
  currPrinterCardData : any = {};
  orderDataList = [];
  successfulDelayPrintEventsIds = [];
  disconnectedPrinterIds: Set<string> = new Set<string>();
  allEventsOfAOrderPrintedSuccessfully: { [orderId: string]: boolean } = {};
  isNoDelayPrintModalOpen: boolean = false;

  constructor(
    private _modalRef: NzModalRef,
    private _modalService: NzModalService,
    private _printStatusService: PrinterStatusService,
    private _printService: PrintService,
    private _translateService: TranslateService
  ) {}

  ngOnInit() {
    this.subscription.add(
      this._translateService
        .get(['PRINTER_STATUS'])
        .subscribe((translation) => {
          this.translationText = translation.PRINTER_STATUS;
        })
    );

    this._printStatusService.allDelayPrintEvents$.subscribe((data) => {
      this.orderDataList = data;
      if (this.orderDataList.length === 0) {
        this.currPrinterCardData = {};
        if (!this.isNoDelayPrintModalOpen) {
          this.isNoDelayPrintModalOpen = true;
          this.callNoDelayEventsModal();
        }
        this.cancelClicked(); // close current delay print modal
      } else if (this.orderDataList.length > 0) {
        this.currPrinterCardData = this.orderDataList[0] || {};
      }
    },
    (error) => {
      // Handle error here
      console.error('Error in allDelayPrintEvents$ subscription:', error);
    });
    this._printService.successfulDelayPrintingIds$.subscribe((data) => {
      this.successfulDelayPrintEventsIds = data || [];
    },
    (error) => {
      // Handle error here
      console.error('Error in successfulDelayPrintingIds$ subscription:', error);
    });
  }

  trackOrder(index, order) {
    return order ? order.order_id : undefined;
  }

  cancelClicked() {
    this._modalRef.close();
  }

  orderCardClicked(order) {
    this.currPrinterCardData = order || {};
  }

  async printNotNeededClicked(itrEvent: any) {
    try {
      const acknowledgmentPromises = (
        (itrEvent || {}).printer_events || []
      ).map(async (eventData) => {
        try {
          this.acknowledgePrintEventApi(eventData);
        } catch (ackError) {
          // It won't stop the processing of other events.
          console.error('Error acknowledging event:', ackError);
        }
      });

      await Promise.all(acknowledgmentPromises);

      // All events have been processed, regardless of errors
      this._printService.getAllDelayPrintEventsDataFromApi();
    } catch (error) {
      console.error('Error during acknowledgment:', error);
    }
  }

  acknowledgePrintEventApi(eventData: any) {
    const eventDataObj = (eventData || {}).event_data || {};
    const payload = {
      printing_id: eventDataObj.printing_id || '',
      printed: eventDataObj.is_printed || true,
      print_not_needed: 1,
    };
    this._printService
    .acknowledgePrintEvent(payload)
    .pipe(take(1))
    .subscribe();
  }

  printManuallyClicked(itrEvents: any) {
    const printerEvents = (itrEvents || {}).printer_events || [];
    const printerIp =
      ((printerEvents[0] || {}).print_data[0] || {}).ptr_name || '';
    const printingId =
      ((printerEvents[0] || {}).event_data || {}).printing_id || '';
    const isPrinterConnected =
      this._printStatusService.isThisPrinterConnected(printerIp);

    if (isPrinterConnected) {
      this._printService.pushManuallyDelayPrintEventsInPrintQueue(
        printerEvents
      );
      setTimeout(() => {
        this.checkAllEventsOfOrderPrinted(this.currPrinterCardData);
      }, 1000);
    } else {
      this.disconnectedPrinterIds.add(printingId);
      setTimeout(() => {
        this.disconnectedPrinterIds.delete(printingId);
      }, 5000);
    }
  }

  checkIsAllEventsPrinted(itrEvents) {
    if (this.successfulDelayPrintEventsIds.length > 0) {
      const printingIds = ((itrEvents || {}).printer_events || []).map(
        (obj: any) => {
          return ((obj || {}).event_data || {}).printing_id;
        }
      );

      const haveSomeValueLeft = (printingIds || []).filter(
        (printingId: any) => {
          return !this.successfulDelayPrintEventsIds.includes(printingId);
        }
      );
      return haveSomeValueLeft.length == 0;
    }
    return false;
  }

  checkAllEventsOfOrderPrinted(delayPrintOrderObj: any) {
    const remaningPrintingIds = [];
    const currOrderId = this.currPrinterCardData['order_id'] || '';

    ((delayPrintOrderObj || {}).itrData || []).forEach((itrObj: any) => {
      ((itrObj || {}).itr_events || []).forEach((itr_eventsObj: any) =>
        ((itr_eventsObj || {}).printer_events || []).forEach(
          (printerEventsObj: any) => {
            if (
              !this.successfulDelayPrintEventsIds.includes(
                ((printerEventsObj || {}).event_data || {}).printing_id
              )
            ) {
              remaningPrintingIds.push(
                ((printerEventsObj || {}).event_data || {}).printing_id
              );
            }
          }
        )
      );
    });
    if (remaningPrintingIds.length === 0) {
      this.allEventsOfAOrderPrintedSuccessfully[currOrderId] = true;
      this._printService.getAllDelayPrintEventsDataFromApi(); // fetch new data
      return true;
    } else {
      return false;
    }
  }

  orderSince(date) {
    const time = new Date().getTime();
    const orderSince = Math.floor(time / 1000) - parseInt(date, 10);

    return this.orderTimingInString(orderSince);
  }

  orderTimingInString(orderSince: number) {
    if (orderSince < 3600) {
      if (orderSince < 60) {
        return this.translationText.A_MIN;
      }
      return Math.floor(orderSince / 60) + ' ' + this.translationText.MINS;
    } else {
      if (orderSince < 3600 * 24) {
        if (orderSince / 3600 == 1) {
          return this.translationText.HOUR;
        }
        return Math.floor(orderSince / 3600) + ' ' + this.translationText.HOURS;
      } else {
        if (orderSince / (3600 * 24) == 1) {
          return this.translationText.DAY;
        }
        return Math.floor(orderSince / (3600 * 24)) + this.translationText.DAYS;
      }
    }
  }

  async callNoDelayEventsModal() {
    const { NoDelayEventsModalComponent } = await import(
      /* webpackPrefetch: true */ '../no-delay-events-modal/no-delay-events-modal.component'
    );
    this._modalService.create({
      nzClosable: false,
      nzContent: NoDelayEventsModalComponent,
      nzBodyStyle: { padding: '0px' },
      nzFooter: null,
      nzWidth: 510,
    });
  }

  checkPrinterStatus() {
    this._printStatusService.openAllPrintersModal();
  }
}
